import { useEffect } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import RecipeCard from "./RecipeCard";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useAuth } from "../contexts/authContext";

export default function RecipeSlidePanel({ isOpen, onClose, recipe }) {
  const { token, isLoggedIn } = useAuth();

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!recipe) return null;

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex justify-center items-end md:items-center bg-black/50 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose} // click outside to close
        >
          <motion.div
            className="w-full md:max-w-2xl rounded-t-2xl md:rounded-b-2xl md:h-[90%] h-[90vh] bg-white overflow-y-auto relative flex flex-col"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            onClick={(e) => e.stopPropagation()} // prevent click inside from closing
            drag="y"
            dragConstraints={{ top: 0, bottom: 0 }}
            dragElastic={0.2}
            onDragEnd={(e, info) => {
              if (info.offset.y > 100) onClose(); // swipe down to close
            }}
            style={{
              paddingBottom: "calc(var(--safe-area-inset-bottom) )", // safe area   + 0.75rem
            }}
          >
            <div className="sticky top-0 bg-white z-10 p-4 pb-0">
              {/* Grab handle on mobile only */}
              <div className="flex justify-center mb-2 pb-4 md:hidden">
                <div className="w-10 h-1 rounded bg-gray-300"></div>
              </div>
              <div className="hidden md:flex justify-end px-4">
                <button onClick={onClose} className="text-gray-400 hover:text-black text-2xl">
                    <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="px-4 overflow-y-auto flex-1">
              <RecipeCard recipe={recipe} />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
